import { render, staticRenderFns } from "./z-report.vue?vue&type=template&id=21c2c031"
import script from "./z-report.vue?vue&type=script&lang=js"
export * from "./z-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports